import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mediathek',
  templateUrl: './mediathek.component.html',
  styleUrls: ['./../app.component.css']
})
export class MediathekComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
